class VisualizationModeDefinition {
    visualizationMode: KnockoutObservable<VisualizationModeEnum> = ko.observable(VisualizationModeEnum.Value);
    barChartText: KnockoutObservable<BarChartTextEnum> =  ko.observable(BarChartTextEnum.Value);
    barChartTextPosition: KnockoutObservable<BarChartTextPositionEnum> = ko.observable(BarChartTextPositionEnum.End);
    color: KnockoutObservable<string> = ko.observable();
    negativeColor: KnockoutObservable<string> = ko.observable();

    constructor(data?: any) {
        if (!data) {
            return;
        }

        this.visualizationMode(data.visualizationMode);
        this.barChartText(data.barChartText);
        this.barChartTextPosition(data.barChartTextPosition);
        this.color(data.color);
        this.negativeColor(data.negativeColor);
    }
}

enum VisualizationModeEnum {
    Value,
    BarChart
}

enum BarChartTextEnum {
    None,
    Value,
    Percentage
}

enum BarChartTextPositionEnum {
    Begin,
    Center,
    End
}